/**
 * External Dependants
 */
import React from 'react';
import classNames from 'classnames';


/**
 * Inernal Dependants
 */
const Section = ({ children, className }) => {
    const classes = classNames('topbar__section', className );
    return (
        <div className={classes}>
            {children}
        </div>
    );
};

export default Section;
